// Colors
export const COLORS = {
	GREEN: "#43d271",
	BLUE: "#1e91ff",
	TEAL: "#26a69a",
	ORANGE: "#ffa950",
	RED: "#fd7171",
	PURPLE: "#e26cf5",
	CYAN: "#26c6da",
	WHITE: "#ffffff",
	LIME: "#c0ca33",
	AMBER: "#ffca28",
	INDIGO: "#5c6bbf",
	TRANSPARENT: "rgba(0,0,0,0)",
	MUTED: "#6a8ca3",
};

// Font
export const FONT = {
	FAMILY_SANS_SERIF: "Roboto",
	SIZE_XS: "10px",
	SIZE_SM: "11px",
};